
/**
 * Shows an alert if the user has not yet confirmed their email address.
 *
 * @param {import('../ForumApplication').default} app
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {

  onSuccess(app, text) {
    app.alerts.show({ type: 'success', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  onWarn(app, text) {
    app.alerts.show({ type: 'warn', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  onError(app, text) {
    app.alerts.show({ type: 'error', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
  },

  commonJson() {
    const str = "{\"zh-Hans\":\"\",\"zh-Hant\":\"\",\"en\":\"\",\"de\":\"\",\"fr\":\"\",\"vi\":\"\",\"ko\":\"\"}";
    return str;
  },

  commonTwoJson() {
    const str = "{\"phone\":{\"zh-Hans\":\"\",\"zh-Hant\":\"\",\"en\":\"\",\"de\":\"\",\"fr\":\"\",\"vi\":\"\"},\"pc\":{\"zh-Hans\":\"\",\"zh-Hant\":\"\",\"en\":\"\",\"de\":\"\",\"fr\":\"\",\"vi\":\"\"}}";
    return str;
  },

  checkUsername(username) {
    const regex = /^[a-zA-Z][0-9a-zA-Z_]{5,16}$/;
    if (!regex.test(username) || username.length < 6 || username.length > 32) {
      return false;
    }
    return true;
  },

  checkEmail(email) {
    const regex =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      return false;
    }
    return true;
  },

  checkPwd(pwd) {
    if (pwd.length < 6 || pwd.length > 32) {
      return false;
    }
    return true;
  },

  checkCode(code) {
    const regex =  /^\d{6}$/;
    if (!regex.test(code)) {
      return false;
    }
    return true;
  },

}
